import React from "react";
import type { FC } from "react";
import type { RadioChangeEvent } from "antd";
import { Card, List } from "antd";
import { RadioCard } from "./QuestionTypes";
import { useLocation } from "umi";

interface Props { problems: API.radioProblemStudentResult[]; onChange?: (value: API.radioProblemStudentResult[]) => void }
/** 选择题列表 */
const RadioList: FC<Props> = ({ problems, onChange }) => {
    const { query } = useLocation() as unknown as Location & { query: Record<string, string> };
    const newProblems = [...problems];
    /** 选项改变 */
    const onNewChange = (val: RadioChangeEvent, problem: API.radioProblemStudentResult) => {
        window.Pandora.send('zijin_testee_change_titleindex', {
            onlyid: query.exam_id,
            index: problem.num,
            type: 'radio'
          });
        problem.reply = val.target.value;
        onChange?.(newProblems);
    };
    return <Card style={{ width: 750, height: 'calc(100vh - 64px - 40px)', margin: '20px auto' }}>
        <div style={{ overflow: 'auto', height: 'calc(100vh - 64px - 84px)' }}>
            <List
                dataSource={newProblems}
                split={false}
                renderItem={(item) => (
                    <List.Item key={item.problemId} style={{ display: 'flex', flexDirection: 'column' }}>
                        {Number.isInteger(item.score) 
                            ? <div style={{ height: 25, textAlign: 'left' }}>{item.num}【{item.score === 0 ? '0 分，错误' : item.score + '分，正确'}】</div>
                            : <div style={{ height: 25 }}>{item.num}</div>
                        }
                        <RadioCard
                            src={item.src}
                            answers={item.answers}
                            selectAnswer={item.reply}
                            onChange={(e) => onNewChange(e, item)}
                        />
                    </List.Item>
                )}
            />
        </div>
    </Card>;
};

export default RadioList;